export default __webpack_public_path__ + "static/online-8cac6b1ae8c4f1c47d05ebabaa462d87.png";